import type { FormikProps } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { BranchCreationInput } from '../types'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const SummaryStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  return (
    <>
      <p>{translate('branchCreationWizard.summaryStep.description')}</p>

      <div className="grid grid-cols-[auto_1fr] gap-x-4">
        <div>{translate('branchCreationWizard.summaryStep.category')}</div>
        <div>{values.category}</div>
        <div>{translate('branchCreationWizard.summaryStep.component')}</div>
        <div>{values.server}</div>
        <div>{translate('branchCreationWizard.summaryStep.branchName')}</div>
        <div>{values.branchName}</div>
        <div>{translate('branchCreationWizard.summaryStep.baseBranch')}</div>
        <div>{values.baseBranch?.name ?? '-'}</div>
        <div>{translate('branchCreationWizard.summaryStep.followsBranch')}</div>
        <div>{values.followsBranch?.name ?? '-'}</div>
        <div>{translate('branchCreationWizard.summaryStep.import')}</div>
        <div>{values.importFromFile?.at(0)?.name ?? '-'}</div>
        <div>{translate('branchCreationWizard.summaryStep.types')}</div>
        <div>
          {values.typeVersionFile?.at(0)
            ? `${values.typesVersionName}, ${values.typeVersionFile?.at(0)?.name}`
            : '-'}
        </div>
      </div>
    </>
  )
}
